import { lazy } from 'react';
import { decisionTaggingIcon, generalIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/fees-management';

const MainView = lazy(
  () =>
    import(/* webpackChunkName: "FeesManagementRoutes" */ '../pages/MainView')
);
const PromosView = lazy(
  () =>
    import(/* webpackChunkName: "FeesManagementPromos" */ '../pages/PromosView')
);

export const feesManagementRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Fees management',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: generalIcon,
      pages: []
    },
    {
      name: 'Promos',
      path: `${BASE_PATH}/promos`,
      component: PromosView,
      exact: false,
      icon: decisionTaggingIcon,
      pages: []
    }
  ]
};
